import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const KEY = 'carbi_day_history';
const today = () => new Date().toISOString().slice(0, 10);

export function loadDayEntries() {
  try {
    const stored = JSON.parse(localStorage.getItem(KEY));
    return stored?.date === today() ? stored.items : [];
  } catch {
    return [];
  }
}

export function saveDayEntry(entry) {
  const items = [entry, ...loadDayEntries()].slice(0, 20);
  localStorage.setItem(KEY, JSON.stringify({ date: today(), items }));
  return items;
}

export const DayHistory = ({ entries }) => {
  if (!entries.length) return null;
  return (
    <Card data-testid="day-history">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">Cálculos de hoy</CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        <ul className="flex flex-col divide-y divide-border">
          {entries.map((e, i) => (
            <li key={i} className="flex items-center justify-between gap-3 py-2.5" data-testid={`day-entry-${i}`}>
              <div className="min-w-0">
                <p className="text-sm text-muted-foreground">{e.time}</p>
                <p className="text-base text-foreground truncate">{e.summary}</p>
              </div>
              <span className="shrink-0 text-base font-bold text-primary whitespace-nowrap">{e.total} g</span>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
};
